import { RouteContentProductAppMap } from 'utils/routing/routeProductMaps'
import {
  isK5Dashboard,
  isMiddleSchoolDashboard,
} from 'utils/routing/routeHelpers'

export const K5_DASHBOARD_ROUTE = '/dashboard/grades-k-5'
export const MIDDLE_SCHOOL_DASHBOARD_ROUTE = '/dashboard/grades-6-8'

export function resolveK8DashboardRoute() {
  if (isK5Dashboard()) {
    return K5_DASHBOARD_ROUTE
  }

  if (isMiddleSchoolDashboard()) {
    return MIDDLE_SCHOOL_DASHBOARD_ROUTE
  }

  return ''
}

export const K8_DASHBOARD_CURRICULUM_OPTIONS = {
  app: RouteContentProductAppMap.learnEducatorDashboard,
  routeResolver: resolveK8DashboardRoute,
}
